import React, { useMemo } from 'react';
import renderers from './rericos/renderers/index.js';
import { decorators } from './rericos/decorators/index.js';
import { getPluginRenderers } from './rericos/renderers/plugins/getPluginRenderers.js';
import RicosNodesRenderer from './RicosNodesRenderer.js';
import { RicosContextProvider, ContentTraverserContextProvider, RicosViewerContextProvider, RicosDirectionContextProvider, SpoilerContextProvider, RicosNodeContextProvider } from 'ricos-context';
import SpoilerManager from './rericos/utils/SpoilerManager.js';
import { Decorators } from './rericos/decorators/nodeViewDecorators.js';
import 'ricos-schema';
import './rericos/renderers/paragraph/paragraph.js';
import '../alignment.rtlignore-7b24e049.js';
import '../rtl.rtlignore-d0a8260b.js';
import '../indentation-a4f1bb61.js';
import './rericos/renderers/consts.js';
import 'classnames';
import './rericos/utils/Anchorable.js';
import './rericos/utils/paywallSeo.js';
import 'wix-rich-content-common';
import './rericos/renderers/blockquote/blockquote.js';
import 'ricos-converters';
import './rericos/renderers/codeblock/codeblock.js';
import './rericos/renderers/heading/heading.js';
import './rericos/renderers/lists/bulletedList.js';
import '../lists-9abf4fc0.js';
import './rericos/renderers/lists/orderedList.js';
import './rericos/renderers/lists/listItem.js';
import './rericos/renderers/text/text.js';
import 'ricos-common-plugins/viewer';
import './rericos/renderers/plugins/fromExternalNode.js';
import 'ricos-content/libs/struct-converters';
import '../getClassNames-579a0e38.js';
import 'lodash';
import './rericos/renderers/plugins/nodeViewContainer.js';
import './rericos/renderers/plugins/ContainerElement.js';
import './components/ErrorBoundary.js';
import './rericos/render.js';
import './components/Anchor.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ContentTraverser = ({
  content,
  context,
  typeMappers,
  nodeViewRenderers,
  nodeViewDecorators,
  SpoilerViewerWrapper,
  addAnchorsPrefix
}) => {
  const { nodes } = content;
  const spoilerManager = new SpoilerManager();
  const allRenderers = useMemo(
    () => __spreadValues(__spreadValues({}, renderers), getPluginRenderers(context, typeMappers, nodeViewRenderers, SpoilerViewerWrapper)),
    []
  );
  const allDecorators = useMemo(() => {
    return Decorators.of([...decorators, ...nodeViewDecorators], context);
  }, []);
  const ricosContext = useMemo(() => {
    const { t, locale, isMobile, theme, experiments, languageDir } = context;
    return {
      t,
      locale,
      isMobile,
      theme,
      experiments,
      languageDir
    };
  }, []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(RicosContextProvider, __spreadValues({}, ricosContext), /* @__PURE__ */ React.createElement(
    ContentTraverserContextProvider,
    {
      nodeViewDecorators: allDecorators,
      renderers: allRenderers,
      SpoilerViewerWrapper
    },
    /* @__PURE__ */ React.createElement(RicosViewerContextProvider, { contextualData: context }, /* @__PURE__ */ React.createElement(RicosDirectionContextProvider, { textDirection: context.textDirection }, /* @__PURE__ */ React.createElement(SpoilerContextProvider, { spoilerManager }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: null, parentIndex: 0 }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes, isRoot: true, addAnchorsPrefix })))))
  )));
};

export { ContentTraverser as default };
//# sourceMappingURL=ContentTraverser.js.map
